// extracted by css-extract-rspack-plugin
var _1 = "cDg9ajKUlENM2kzg";
export { _1 as "fieldMessageWrapper" }
